import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '../../common/common.module';
import {InformoComponent} from '../../cities/informo/informo/informo.component';
import {RealTimeLegendComponent} from '../../cities/informo/real-time-legend/real-time-legend.component';
import {_defaultlivetypes, _defaultupcomingtypes} from 'app/common/const';
import {TrafficsLightPopupComponent} from 'app/cities/informo/traffics-light-popup/traffics-light-popup.component';
import {TrafficIntensityPopupComponent} from 'app/cities/informo/traffics-intensity-popup/traffics-intensity-popup.component';
import {NavigationToolsComponent} from 'app/cities/informo/navigation-tools/navigation-tools.component';
import {InformoService} from 'app/cities/informo/informo.service';
import {environment} from 'environments/environment';
import {FaqComponent} from 'app/cities/informo/faq/faq.component';
import {PollutionAlertsComponent} from 'app/cities/informo/pollution-alerts/pollution-alerts.component';
import {PlatesSearcherComponent} from './plates-searcher/plates-searcher.component';
import {MvtService} from '../../common/services/mvt.service';


export const INFORMOROUTETYPES = [
  {
    idText: 'ACOUSTIC_WARNINGS',
    name: 'Acoustic warnings',
    icon: 'avisadores-acusticos.svg',
    source: 'informo',
    groupBy: 'subtype',
    showing: true,
    downloadDataTitle: 'Incidencias en vía pública',
    downloadData: 'https://datos.madrid.es/portal/site/egob/menuitem.c05c1f754a33a9fbe4b2e4b284f1a5a0/' +
      '?vgnextoid=e2cc3624118d3410VgnVCM2000000c205a0aRCRD&vgnextchannel=374512b9ace9f310VgnVCM100000171f5a0aRCRD&vgnextfmt=default'
  },
  {
    idText: 'TRAFFIC_LIGHT',
    name: 'Traffic lights',
    icon: 'traffic_light.svg',
    source: 'informo',
    groupBy: 'active',
    showing: true,
    downloadDataTitle: 'Incidencias en vía pública',
    downloadData: 'https://datos.madrid.es/portal/site/egob/menuitem.c05c1f754a33a9fbe4b2e4b284f1a5a0/' +
      '?vgnextoid=fb736ca2dd8f4410VgnVCM2000000c205a0aRCRD&vgnextchannel=374512b9ace9f310VgnVCM100000171f5a0aRCRD'
  },
  {
    idText: 'CAMERA',
    name: 'Cameras',
    icon: 'camera.svg',
    source: 'informo',
    showing: true,
    downloadDataTitle: 'Incidencias en vía pública',
    downloadData: 'https://datos.madrid.es/portal/site/egob/menuitem.c05c1f754a33a9fbe4b2e4b284f1a5a0/' +
      '?vgnextoid=8803c23866b93410VgnVCM1000000b205a0aRCRD&vgnextchannel=374512b9ace9f310VgnVCM100000171f5a0aRCRD&vgnextfmt=default'
  },
  {
    id: 0,
    idText: 'ACCIDENT',
    name: 'Accidents',
    icon: 'accident.svg',
    groupBy: 'subtype',
    showing: true
  },
  {
    id: 2,
    idText: 'WEATHERHAZARD',
    name: 'WEATHERHAZARD',
    icon: 'hazard.svg',
    groupBy: 'subtype',
    showing: true
  }, {
    id: 4,
    idText: 'CONSTRUCTION',
    name: 'Construction',
    icon: 'construction.svg',
    groupBy: 'type',
    showing: true
  }, {
    id: 5,
    idText: 'ROAD_CLOSED',
    name: 'Road closed',
    icon: 'road_closed.svg',
    groupBy: 'subtype',
    showing: true
  }, {
    id: 3,
    idText: 'MISC',
    name: 'Misc',
    icon: 'misc.svg',
    groupBy: 'type',
    showing: true
  }, {
    id: 7,
    idText: 'EVENT',
    name: 'Events',
    icon: 'event.svg',
    groupBy: 'type',
    showing: true
  }
];

const __informo: any = environment.options.sources.includes('informo') ?
  [
    {
      id: 9,
      idText: 'SERVICE_LEVELS',
      name: 'Service levels',
      icon: 'service_level.svg',
      source: 'informo',
      groupBy: 'status',
      showing: true,
      downloadDataTitle: 'Datos del tráfico en tiempo real',
      downloadData: 'https://datos.madrid.es/portal/site/egob/menuitem.c05c1f754a33a9fbe4b2e4b284f1a5a0/' +
        '?vgnextoid=02f2c23866b93410VgnVCM1000000b205a0aRCRD&vgnextchannel=374512b9ace9f310VgnVCM100000171f5a0aRCRD'

    },
    {
      id: 9,
      idText: 'INTENSITY_LEVELS',
      name: 'Intensity levels',
      icon: 'service_level.svg',
      source: 'informo',
      groupBy: 'intensity',
      showing: false,
      downloadDataTitle: 'Mapa de tramas de intensidad del tráfico',
      downloadData: 'https://datos.madrid.es/sites/v/index.jsp?vgnextoid=02f2c23866b93410VgnVCM1000000b205a0aRCRD' +
        '&vgnextchannel=374512b9ace9f310VgnVCM100000171f5a0aRCRD'
    },
    {
      idText: 'ACOUSTIC_WARNINGS',
      name: 'Acoustic warnings',
      icon: 'avisadores-acusticos.svg',
      source: 'informo',
      groupBy: 'subtype',
      showing: false,
      downloadDataTitle: 'Semáforos con avisadores acústicos',
      downloadData: 'https://datos.madrid.es/portal/site/egob/menuitem.c05c1f754a33a9fbe4b2e4b284f1a5a0/' +
        '?vgnextoid=e2cc3624118d3410VgnVCM2000000c205a0aRCRD&vgnextchannel=374512b9ace9f310VgnVCM100000171f5a0aRCRD' +
        '&vgnextfmt=default'
    },
    {
      idText: 'TRAFFIC_LIGHT',
      name: 'Traffic lights',
      icon: 'traffic_light.svg',
      source: 'informo',
      groupBy: 'active',
      showing: false,
      downloadDataTitle: 'Semáforos con control Foto-Rojo',
      downloadData: 'https://datos.madrid.es/portal/site/egob/menuitem.c05c1f754a33a9fbe4b2e4b284f1a5a0/' +
        '?vgnextoid=fb736ca2dd8f4410VgnVCM2000000c205a0aRCRD&vgnextchannel=374512b9ace9f310VgnVCM100000171f5a0aRCRD'
    },
    {
      idText: 'CAMERA',
      name: 'Cameras',
      icon: 'camera.svg',
      source: 'informo',
      showing: false,
      groupBy: 'subtype',
      downloadDataTitle: 'Cámaras',
      downloadData: 'https://datos.madrid.es/portal/site/egob/menuitem.c05c1f754a33a9fbe4b2e4b284f1a5a0/' +
        '?vgnextoid=8803c23866b93410VgnVCM1000000b205a0aRCRD&vgnextchannel=374512b9ace9f310VgnVCM100000171f5a0aRCRD' +
        '&vgnextfmt=default'
    }] : [];

export const INFORMOLIVETYPES = __informo.concat(_defaultlivetypes.filter(t => {
  t['downloadDataTitle'] = 'Incidencias en vía pública';
  t['downloadData'] = 'https://datos.madrid.es/portal/site/egob/menuitem.c05c1f754a33a9fbe4b2e4b284f1a5a0/' +
    '?vgnextoid=40085fb0e70b7410VgnVCM2000000c205a0aRCRD&vgnextchannel=374512b9ace9f310VgnVCM100000171f5a0aRCRD&vgnextfmt=default';
  return environment.options.sources.includes('waze') ? true : t.idText !== 'JAM';
}));

export const INFORMOUPCOMINGTYPES = [
  ..._defaultupcomingtypes,
];

export const INFORMO = [
  {
    mode: 'live',
    modeName: 'Live',
    active: true,
    sources: [
      {
        id: 'informo',
        name: 'Ayuntamiento de Madrid',
        showing: true
      },
      // {
      //   id: 'waze',
      //   name: 'Pura literatura',
      //   showing: true
      // }
    ],
    types: INFORMOLIVETYPES
  },
  {
    mode: 'upcoming',
    modeName: 'Upcoming',
    sources: [{
      id: 'informo',
      name: 'Ayuntamiento de Madrid',
      showing: true
    }],
    types: INFORMOUPCOMINGTYPES,
  },
  {
    mode: 'plates',
    modeName: 'matrículas',
    sources: [],
    types: []
  },
  {
    mode: 'route',
    modeName: 'Route',
    hidden: true,
    sources: [{
      id: 'waze',
      name: 'Waze',
      showing: true,
    }, {
      id: 'informo',
      name: 'Ayuntamiento de Madrid',
      showing: true
    }],
    types: INFORMOROUTETYPES,
  }
];


const components = [
  InformoComponent,
  RealTimeLegendComponent,
  NavigationToolsComponent,
  PlatesSearcherComponent,
  TrafficsLightPopupComponent,
  TrafficIntensityPopupComponent,
  PollutionAlertsComponent,
  FaqComponent
];

@NgModule({
  imports: [CommonModule, FormsModule],
  exports: [],
  declarations: components,
  providers: [
    {
      provide: MvtService,
      useClass: InformoService
    },
    InformoService

  ],
  entryComponents: [...components]
})
export class InformoModule {
}



// WEBPACK FOOTER //
// ./src/app/cities/informo/informo.module.ts